import barba from "@barba/core";
import Sticky from "sticky-js";

const initReferences = () => {
	const references = document.querySelectorAll(".references:not(.is-initialized)");

    if (references.length) {
        let sticky = null;
		sticky = new Sticky(".references__scroll__sticky", {
			marginTop: 308,
        });
        Array.from(document.images).forEach((image) => {
            image.addEventListener("load", () => {
                sticky.update();
            });
        });

		references.forEach(reference => {
			const scroll = reference.querySelector(".references__scroll");
			if (scroll) {
				const sticky = scroll.querySelector(".references__scroll__sticky");
				const update = () => {
					const stickyHeight = sticky.offsetHeight;
					scroll.style.paddingTop = `${stickyHeight}px`;
				};
				update();
				window.addEventListener("resize", update);
			}
			reference.querySelectorAll(".references__list__item").forEach(item => {
				const floater = item.querySelector(".references__list__item__floater");
				const updateFloater = () => {
					const itemPos = item.getBoundingClientRect();
					const x = window.cursorPosition.x - (itemPos.left + item.offsetWidth / 4) + 45;
					const y = window.cursorPosition.y - (itemPos.top + (item.offsetHeight / 2) - 35) - 15;
					floater.style.transform = `translate3d(${x}px, ${y}px, 0)`;
				};

				item.addEventListener("mouseenter", () => {
					floater.classList.add("references__list__item__floater--is-visible");
					window.addEventListener("mousemove", updateFloater, { passive: true });
				}, { passive: true });

				item.addEventListener("mouseleave", () => {
					floater.classList.remove("references__list__item__floater--is-visible");
					window.removeEventListener("mousemove", updateFloater, { passive: true });
				}, { passive: true });
			});

			reference.classList.add("is-initialized");
		});
	}
};

barba.hooks.beforeEnter(initReferences);
document.addEventListener("DOMContentLoaded", initReferences);
